import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HasPermissionDirective } from './has-permission.directive';
import { HasPermissionGuard } from './has-permission.guard';
import { IsAuthorisedGuard } from './is-authorised.guard';
import { IsIpRestrictedGuard } from './is-ip-restricted.guard';
import { IsManagementDirective } from './is-management.directive';
import { IsManagementGuard } from './is-management.guard';
import { IsNotAuthorisedGuard } from './is-not-authorised.guard';
import { IsTimeRestrictedGuard } from './is-time-restricted.guard';
import { ManagementService } from './management.service';
import { MultifactorEnforcementGuard } from './multifactor-enforcement.guard';

@NgModule({
  imports: [CommonModule, HasPermissionDirective, IsManagementDirective],
  providers: [
    ManagementService,
    IsAuthorisedGuard,
    IsManagementGuard,
    IsNotAuthorisedGuard,
    HasPermissionGuard,
    IsIpRestrictedGuard,
    IsTimeRestrictedGuard,
    MultifactorEnforcementGuard,
  ],
  exports: [HasPermissionDirective, IsManagementDirective],
})
export class AuthModule {}
